import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { useEffect, useRef } from 'react';

import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import { headerMobileSubMenuWrapperDelay } from 'src/components/layout/redesign/header-mobile/header-mobile-helper';

import HeaderMobileBottomNav from './header-bottom-nav';
import * as styles from './header-sub-menu-wrapper.module.scss';

type HeaderMobileSubMenuWrapperProps = {
  children: ReactNode;
  isMenuOpen: boolean;
  isVisible: boolean;
  isChildMenuVisible: boolean;
  level?: number;
  primaryButton?: HeaderButtonProps;
  secondaryButton?: HeaderButtonProps;
  searchButton?: HeaderButtonProps;
  linkDropdownCta?: Queries.LinkDropdownCta;
};

const HeaderMobileSubMenuWrapper = (props: HeaderMobileSubMenuWrapperProps) => {
  const scrollDivRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (props.isVisible) {
      return;
    }

    const timeout = setTimeout(() => {
      scrollDivRef.current?.scrollTo?.(0, 0);
    }, headerMobileSubMenuWrapperDelay);

    return () => clearTimeout(timeout);
  }, [props.isVisible]);

  const leftValue = props.isVisible
    ? '0'
    : props.isChildMenuVisible
      ? '-100%'
      : props.level === 1
        ? '0'
        : '100%';

  const wrapperStyle = {
    '--submenu-left': leftValue,
  } as React.CSSProperties;

  return (
    <div
      className={classNames(
        'header-sub-menu',
        styles.container,
        styles.animated,
        props.isVisible && styles.visible,
        props.isMenuOpen && styles.menuOpen
      )}
      style={wrapperStyle}
    >
      <div className={styles.wrapper} ref={scrollDivRef}>
        {props.children}
      </div>
      {props.level === 1 && (
        <HeaderMobileBottomNav
          isMenuOpen={props.isMenuOpen}
          primaryButton={props.primaryButton}
          secondaryButton={props.secondaryButton}
          searchButton={props.searchButton}
          linkDropdownCta={props.linkDropdownCta}
        />
      )}
    </div>
  );
};

export default HeaderMobileSubMenuWrapper;
